import { Module } from 'vuex-smart-module';
import OrderActions from './actions';
import OrderGetters from './getters';
import OrderMutations from './mutations';
import OrderState from './state';
import OrdersInvoices from './modules/orders-invoices';

export default new Module({
  state: OrderState,
  mutations: OrderMutations,
  actions: OrderActions,
  getters: OrderGetters,
  modules: {
    orders_invoices: OrdersInvoices,
  },
});
